export declare namespace AppDataTableTokenSections {
	interface Empty {
		color: string;
		fontSize: string;
		lineHeight: string;
		padding: string;
	}
}

export type AppDataTableTokens = {
	empty: AppDataTableTokenSections.Empty;
};

/** The single cell a table shows across its columns while it has no rows: the library data table's body cell look. */
export const empty: AppDataTableTokenSections.Empty = {
	color: '{datatable.row.color}',
	fontSize: '0.75rem',
	lineHeight: '1.25rem',
	padding: '{datatable.body.cell.padding}',
};

/** `app-data-table`: the table text and the empty-message cell every table shares. */
export default {
	empty,
} satisfies AppDataTableTokens;
